export const MATCH_CANDIDATE_LIMIT = 2000;

/**
 * The most companies one match's pool may hold — genesis's `MatchCompanyController.MAX_MATCH_COMPANIES`,
 * mirrored.
 *
 * A SECOND PIN OF THE SAME NUMBER, and deliberately so: genesis refuses the write past this point
 * with a catalogued message (`TOO_MANY_MATCH_COMPANIES` in lib/genesis-error-codes), so this copy
 * exists only to say "full" before the click rather than after it — the same arrangement the
 * company expertise editor has with its own cap. If the two drift, spark refuses at the lower
 * number and quotes it; nothing over-fills, because the enforced cap is genesis's.
 *
 * The person pool's constant above happens to hold the same value and is NOT the same rule:
 * `match_candidate` carries no server-side cap at all (genesis#279), so MATCH_CANDIDATE_LIMIT is a
 * client-side batch bound and this one is a server contract. Changing one says nothing about the
 * other.
 */
export const MATCH_COMPANY_LIMIT = 2000;
